(() => {
  const selector = 'a[data-fancybox]';
  let pending;
  let opening = false;

  function loadLightbox() {
    if (pending) return pending;
    pending = Promise.all([
      new Promise((resolve, reject) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.css';
        link.onload = resolve;
        link.onerror = reject;
        document.head.append(link);
      }),
      new Promise((resolve, reject) => {
        if (window.Fancybox) return resolve();
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.umd.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.append(script);
      }),
    ]);
    return pending;
  }

  // Warm up only on intent, keeping lightbox assets off the initial render path.
  ['pointerover', 'focusin'].forEach((type) => {
    document.addEventListener(type, (event) => {
      if (event.target.closest?.(selector)) loadLightbox().catch(() => {});
    }, { passive: true });
  });

  document.addEventListener('click', async (event) => {
    const link = event.target.closest?.(selector);
    if (!link || event.defaultPrevented || event.button !== 0
      || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (opening) return;
    opening = true;
    try {
      await loadLightbox();
      const links = [...document.querySelectorAll(selector)]
        .filter((item) => item.dataset.fancybox === link.dataset.fancybox);
      window.Fancybox.show(links.map((item) => ({
        src: item.href,
        type: 'image',
        caption: item.dataset.caption,
        thumbSrc: item.querySelector('img')?.currentSrc,
      })), {
        startIndex: links.indexOf(link),
        dragToClose: false,
        Toolbar: { display: { left: [], middle: [], right: ['zoom', 'slideShow', 'fullScreen', 'thumbs', 'close'] } },
      });
    } catch {
      window.location.assign(link.href);
    } finally {
      opening = false;
    }
  });
})();
